import { API_URL } from "config";
import Http from "util/https";
import { CompanyShopResponseApi, WholeShop } from "../types";

/**
 * 企業に紐づいている店舗取得Api
 * @param companyCd 企業コード
 * @returns レスポンスデータ
 */
export default async function getShopOptionsApi(companyCd: string): Promise<WholeShop[]> {
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/company/stores?company_cd=${companyCd}`;
  const res = await http.get<CompanyShopResponseApi>(url);
  console.log(res);

  // const res: {data: WholeShopResponseApi} = {data: {
  //   stores: [{
  //     client_cd: "000001",
  //     store_name: "店舗1",
  //     is_client: false
  //   },{
  //     client_cd: "000002",
  //     store_name: "店舗2",
  //     is_client: false
  //   },{
  //     client_cd: "000003",
  //     store_name: "得意先1",
  //     is_client: true
  //   },{
  //     client_cd: "000004",
  //     store_name: "得意先2",
  //     is_client: true
  //   }]
  // }}

  const wholeShopOptions: WholeShop[] = res.data.stores.map((wso) => ({
    clientCd: wso.client_cd ?? '',
    shopName: wso.store_name ?? '',
    isClient: wso.is_client ?? ''
  }));
  return wholeShopOptions;
}
